'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

var CardActions = function CardActions(_ref) {
  var className = _ref.className,
      children = _ref.children;

  var actions = _react2.default.Children.map(children, function (action, index) {
    var actionClasses = action.props.className;
    var classes = (0, _classnames2.default)(actionClasses, 'mdc-card__action');
    return _react2.default.cloneElement(action, { key: index, className: classes });
  });

  return _react2.default.createElement(
    'section',
    {
      className: (0, _classnames2.default)('mdc-card__actions', className)
    },
    actions
  );
};
CardActions.propTypes = propTypes;
exports.default = CardActions;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Card/CardActions.js
// module id = 265
// module chunks = 0